<template>
  <div>
    <el-tabs value="tab_pannel" type="border-card" v-model="activeName">
      <el-tab-pane label="支付管理" name="tab_1">

        <el-form ref="form" :model="formQuery" inline size="mini">

          <el-form-item label="支付渠道ID：">
            <el-input v-model="formQuery.payId"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click.native.prevent="()=>{formVisible=true,isEdit = false;}">添加支付
            </el-button>

            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>


        <el-table :data="List" size="mini">

          <el-table-column type="expand">
            <template v-slot:="props">
              <el-table-column type="expand">
                <template v-slot:="props">
                  <vue-json-editor v-model="props.row" :showBtns="true"></vue-json-editor>
                </template>
              </el-table-column>
            </template>
          </el-table-column>

          <el-table-column label="支付ID" prop="_id" width="200"/>
          <el-table-column label="销售主体" prop="saleEntity" width="200" :formatter="getSaleEntity"/>
          <el-table-column label="支付介绍" prop="info" width="500"/>

          <el-table-column label="操作" width="400">
            <template v-slot:="scope">
              <el-button style="margin-left: 10px;"
                         size="mini"
                         @click="handleEditVisible(scope.$index, scope.row)">编辑
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination ref="pagination" @change="onPageChange"></Pagination>

      </el-tab-pane>


    </el-tabs>


    <el-dialog title="支付信息" :visible.sync="formVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" size="mini">

        <el-form-item label="支付ID：">
          <el-input v-model="form.payId"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="支付服务ID：">
          <el-input v-model="form.realId"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="所属主体：">
          <SaleEntity
              :saleEntity="form.saleEntity"
              @update:saleEntity="val => form.saleEntity = val"/>
        </el-form-item>

        <el-form-item label="支付信息：">
          <el-input v-model="form.info"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="extra：">
          <vue-json-editor v-model="form.extra" :showBtns="true"></vue-json-editor>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false" @click.native.prevent="handleCancel">取 消</el-button>
        <template v-if="!this.isEdit">
          <el-button type="primary" @click.native.prevent="handleAdd">添加</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click.native.prevent="handleEdit">编辑</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueJsonEditor from '@/components/VueJsonEditor'
import {getSaleEntity} from "@/utils";
import Pagination from "@/components/Pagination.vue";
import SaleEntity from "@/views/components/SaleEntity.vue";

export default {
  components: {Pagination, VueJsonEditor, SaleEntity},
  data() {
    return {
      activeName: 'tab_1',

      form: {
        payId: "",
        realId: "",
        saleEntity: "",
        info: "",
        extra: {},
      },

      List: [],
      formVisible: false,

      formQuery: {
        payId: ""
      },
      isEdit: false,
    }
  },
  methods: {
    getSaleEntity,

    query: function (offset, limit) {
      let params = {
        query: this.formQuery.payId,
        limit,
        offset
      }
      this.$axios.post('/pay/list', params).then(res => {
        this.$message.info('查询支付成功');
        this.List = res.payList;
        if (offset === 0) {
          this.$refs.pagination.reset(res.count);
        } else {
          this.$refs.pagination.setTotal(res.count);
        }
        this.logining = false;
      }).catch(res => {
        this.logining = false;
      })
    },

    onPageChange: function (pageSize, currentPage) {
      this.query((currentPage - 1) * pageSize, pageSize);
    },

    handleQuery: function (row, val) {
      this.query(0, this.$refs.pagination.getSize());
    },

    handleEditVisible: function (index, row) {
      this.form = _.merge({}, row, {payId: row._id});
      this.formVisible = true;
      this.isEdit = true;
    },

    handleEdit: function (index, row) {
      const params1 = _.merge({}, this.form, {
        payId: this.form.payId,
      });
      this.$axios.post('/pay/update', params1).then(res => {
        this.$message.info('修改支付成功');
      }).catch(res => {
      })
    },

    handleDelete: function (index, row) {
      this.$confirm("确认删除支付方式？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "red"
      }).then(() => {
        let params = {
          payId: row._id,
        }
        this.$axios.post('/pay/delete', params).then(res => {
          this.$message.info('删除支付成功');
        }).catch(res => {
          this.logining = false;
        })

      }).catch(() => {
      })
    },

    handleAdd: function () {
      const params1 = _.merge({}, this.form, {});
      this.$axios.post('/pay/create', params1).then(res => {
        this.$message.info('上传支付成功');
      }).catch(res => {
        this.logining = false;
      })
    },

    handleCancel() {
      this.formVisible = false;
      this.resetForm();
    },

    resetForm() {
      this.form = {
        payId: "",
        info: "",
        _id: "",
        extra: {},
        realId: "",
        saleEntity: "",
      }
    },
  },

  watch: {},

  created() {
  },

}
</script>

<style scoped>
</style>
